import { DEFAULT_RISK_MATRIX } from '../types/organization';
/**
 * Convert criticality string to numeric value
 * Matches the risk matrix scale: Not in use=0, Very low=1, Low=2, Medium=3, High=4, Very high=5
 */
export function getCriticalityValue(criticality) {
    switch (criticality) {
        case 'very_high':
            return 5;
        case 'high':
            return 4;
        case 'medium':
            return 3;
        case 'low':
            return 2;
        case 'very_low':
            return 1;
        case 'not_in_use':
            return 0;
        default:
            return 2; // Default to low
    }
}
/**
 * Calculate risk score from criticality and condition
 * Risk Score = Criticality Value × Condition Score
 */
export function calculateRiskScore(criticality, conditionScore) {
    if (!conditionScore)
        return 0;
    const criticalityValue = getCriticalityValue(criticality);
    return criticalityValue * conditionScore;
}
/**
 * Get risk level based on risk score and risk matrix configuration
 */
export function getRiskLevel(riskScore, riskMatrix = DEFAULT_RISK_MATRIX) {
    if (!riskMatrix.enabled || riskScore === 0) {
        return 'low';
    }
    const { thresholds } = riskMatrix;
    if (riskScore <= thresholds.low.max) {
        return 'low';
    }
    else if (riskScore <= thresholds.medium.max) {
        return 'medium';
    }
    else if (riskScore <= thresholds.high.max) {
        return 'high';
    }
    else {
        return 'critical';
    }
}
/**
 * Get risk threshold configuration for a given risk level
 */
export function getRiskThreshold(riskLevel, riskMatrix = DEFAULT_RISK_MATRIX) {
    return riskMatrix.thresholds[riskLevel];
}
/**
 * Get CSS color classes for risk level
 */
export function getRiskColorClasses(riskLevel) {
    switch (riskLevel) {
        case 'low':
            return {
                bg: 'bg-green-100',
                text: 'text-green-800',
                border: 'border-green-300',
            };
        case 'medium':
            return {
                bg: 'bg-yellow-100',
                text: 'text-yellow-800',
                border: 'border-yellow-300',
            };
        case 'high':
            return {
                bg: 'bg-orange-100',
                text: 'text-orange-800',
                border: 'border-orange-300',
            };
        case 'critical':
            return {
                bg: 'bg-red-100',
                text: 'text-red-800',
                border: 'border-red-300',
            };
    }
}
/**
 * Get condition score label
 */
export function getConditionLabel(conditionScore) {
    switch (conditionScore) {
        case 1:
            return 'Very good';
        case 2:
            return 'Good';
        case 3:
            return 'Moderate';
        case 4:
            return 'Poor';
        case 5:
            return 'Very poor or failed';
        default:
            return 'Unknown';
    }
}
